import { AsyncSearchField as CoreAsyncSearchField, type AsyncSearchFieldProps } from '@vox/frontend-react-ui/async-search';
import { RequestError } from '@/shared/ui/RequestState';
import classes from './AsyncSearchField.module.scss';
export type { AsyncSearchOption } from '@vox/frontend-react-ui/async-search';

/** Сохраняет оформление и сообщения Manage поверх общей механики поиска */
export const AsyncSearchField = <TId extends string | number, TData = undefined>(
    props: AsyncSearchFieldProps<TId, TData>
) => (
    <CoreAsyncSearchField<TId, TData>
        {...props}
        classNames={classes}
        unstyled={false}
        ErrorComponent={RequestError}
        clearIcon={<span
            className="pi pi-times"
            aria-hidden="true"
        />}
    />
);
